export enum commonExportEnum {
  MAX_COUNT = 65000, // 异步导出最大限制条数
  DETAIL_MAX_COUNT = 100, // 异步导出最大限制条数,问卷、通用交付物
  EXPORT_DETAIL_MAX_COUNT = 1000, // 异步导出1000条数据
  QR_INDUSTRY_MAX_COUNT = 10,
  PROJECT_INFO = 'projectInfo',
  PROJECTVISIT = 'projectVisit', //项目导出拜访数据
  PLAN_DETAIL_EXECUTE_SITUATION = 'planDetailExecuteSituation', // 项目详情-执行情况-导出
  TASKPOPURL = 'taskPopUrl', // 资讯， 视频精准推广 执行人列表 导出明细
  EXECUTORPOPURL = 'executorPopUrl', //资讯， 视频精准推广详情 推广链接 导出明细
  EXECUTOR = 'executor', //问卷/病例任务-任务详情-执行人列表-导出
  LIVEEXECUTOR = 'liveExecutor', //直播标准服务
  CURRENCYEXECUTOR = 'currencyExecutor', //直播标准服务
  MEETINGEXECUTOR = 'meetingExecutor', // 线上会议审核列表-详情-参会人-导出
  ONLINEMEETINGEXECUTOR = 'onlineMeetingExecutor',//线上会议列表详情 参会人 导出
  MEETINGLOG = 'meetingLog', //线上会议列表详情 会议日志 导出,    线上会议审核列表-详情-会议日志-导出
  INFORMATION = 'information', //资讯审核列表-导出
  VIDEO = 'video', //视频审核列表-导出
  QUESTIONNAIRE = 'questionnaire', //问卷审核列表-导出
  QUESTIONNAIREDETAIL = 'questionnaireDetail', //问卷审核列表-导出导出详情
  QUESTIONNAIREANALYZE = 'questionnaireAnalyze', //问卷审核列表-问卷分析-结果页导出
  FORM_WORD_DOWNLOAD = 'formWordDownload', // 表单管理-导出
  TEMPLATE_WORD_DOWNLOAD = 'templateWordDownload', // 模板管理-导出
  BASICMeeting = 'basicMeeting', //基础会议审核列表
  MEETING_INFO = 'meetingInfo', //会议列表
  VISIT = 'visit', //拜访审核列表
  VISIT_DETAIL = 'visitDetail', //拜访审核列表
  LIVE = 'live', //直播审核列表-导出
  CURRENCY = 'currency', //通用交付物审核列表-导出
  CURRENCYDETAIL = 'currencyDetail', //通用交付物审核列表-导出详情
  CURRENCYANALYZE = 'currencyAnalyze', //通用交付物审核列表-表单分析-结果页导出
  ANNOTATION_DELIVERY = 'annotation', //标注交付物列表-导出
  ANNOTATION_DELIVERY_DETAIL = 'annotationDetail', //标注交付物列表-导出详情
  POPCONTENT = 'popContent', //推广交付物列表-导出
  POPRECORD = 'popRecord', //推广交付物列表-总阅读量,总转发量,总点赞量,总表单量-导出
  STATEMENTDETAIL = 'statementDetail', //结算单列表-操作栏 详情页导出
  STATEMENT_DELIVERY_DETAIL = 'statementDeliveryDetail', //结算单列表-操作栏 详情页导出明细
  STATEMENTDETAILBATCH = 'statementDetailBatch', //结算单列表-操作栏 详情页导出
  STATEMENT_DELIVERY_DETAIL_BATCH = 'statementDeliveryDetailBatch', //结算单列表-操作栏 详情页导出明细
  PAYMENTINFODETAIL = 'paymentInfoDetail', //委托服务清单列表-操作栏 详情页导出清单
  PAYMENTBASE = 'paymentInfoBase', //委托服务清单列表导出清单
  PAYMENTLIST = 'paymentInfo', //委托服务清单列表导出清单
  PAYMENTCOLLECTION = 'paymentCollection', //委回款管理-回款列表-导出
  STATEMENT = 'statementExport', // 结算单列表-操作栏 详情页导出 
  STATEMENT_DETAIL = 'statementDetailExport', // 结算单列表-操作栏 详情页导出 
  CUSTOM = 'custom', //客户列表-导出
  DOCTOR = 'doctor', //医生列表-导出
  REPRESENT_INFO = 'medicalRepresent', // 专员列表-导出
  INDUSTRIAL_DOCTOR = 'industrialDoctor', //工业端医生列表-导出
  INDUSTRIAL_REPRESENT = 'industrialRepresent', //工业端专员列表-导出
  DOCTORQRCODE = 'doctorQRCode', //医生二维码-二维码列表-导出
  PROJECT_AUTO_RULE = 'projectAutoRule', // 自动化规则-导出
  CLOUD_ACCOUNT_RECORD = 'cloudAccountDealerRechargeRecord', //云账户管理-账户管理-导出
  BATCH_ACCOUNT_ORDER = 'batchCloudAccountOrder', //云账户管理-付款记录-导出回单
  COMMON_EXPORT = 'commonExport', // 自定义导出
  TASK_EXECUTOR = 'taskExecutorInfo', // 任务详情执行人-导出
  TASK_POP_CONTENT = 'taskPopContent', // 任务推广内容-导出
  TASK_POP_DETAIL = 'popDetailExport', // 任务推广-导出
  PARTNER_INFO = 'partnerInfo', // 合作方-导出
  OUTSOURCER_EXPORT = 'outsourcerExport', // 外包方-导出

  //药企交付物导出
  INDUSTRIAL_INFORMATION = 'industrialInformation', // 资讯数据-企业
  INDUSTRIAL_VIDEO = 'industrialVideo', // 视频数据-企业
  INDUSTRIAL_QUESTIONNAIRE = 'industrialQuestionnaire', // 问卷数据-企业
  INDUSTRIAL_QUESTIONNAIRE_DELIVERY = 'industrialQuestionnaireDelivery', // 问卷反馈数据-企业
  INDUSTRIAL_VISIT = 'industrialVisit', // 拜访数据-企业
  INDUSTRIAL_VISIT_DELIVERY = 'industrialVisitDelivery', // 拜访数据-企业
  INDUSTRIAL_CURRENCY = 'industrialCurrency', // 通用交付物数据-企业
  INDUSTRIAL_CURRENCY_DELIVERY = 'industrialCurrencyDelivery', // 通用交付物反馈数据-企业
  INDUSTRIAL_BASIC_LIVE = 'industrialBasicLive', // 直播详情-企业
  INDUSTRIAL_BASIC_MEETING = 'industrialBasicMeeting', // 基础会议数据-企业
  INDUSTRIAL_MEETING_INFO = 'industrialMeetingInfo', //会议导出
  INDUSTRIAL_POP = 'industrialPop', // 推广交付物列表-企业
  INDUSTRIAL_POP_RECORD = 'industrialPopRecord', // 推广交付物记录-企业
  PAYMENT_INFO_PAYER = 'paymentInfoPayer', // 制作委托服务清单-选择收款人
  ORGANIZATION_INFO = 'organizationInfo',
}
